import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=d5b57ab8&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"
import style0 from "./Features.vue?vue&type=style&index=0&id=d5b57ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b57ab8",
  null
  
)

export default component.exports